import $ from 'cash-dom';
import { debounce, throttle } from '../utilities/toolkit';

const headers = $('.mobile-header, .desktop-header');

const checkHeaderPosition = () => {
	if (window.pageYOffset > 150) {
		headers.attr('data-scrolling', 'true');
	} else if (window.pageYOffset < 120) {
		headers.attr('data-scrolling', 'false');
	}
};

// Throttle scroll for every 100ms and make passive
window.addEventListener('scroll', throttle(checkHeaderPosition, 100), { passive: true });

// Make final check when we're done scrolling
// sometimes the throttle function misses it
// if you scroll up too fast
window.addEventListener('scroll', debounce(checkHeaderPosition, 150), { passive: true });
